import type { FC } from "react";
import styled from "styled-components";
import { Content } from "src/shared/components/content";
import {
  StyledImage,
  StyledTextBodyDiv,
  TextWrapper,
} from "src/website-apps/responsive/stubhub-about-us/components/stubhub/styled-components";
import { StyledTitle } from "src/website-apps/shared/components/branding/styled-components";
import { ImageSize } from "src/website-apps/shared/components/image";

const CaptionName = styled.div`
  ${({
    theme: {
      typography: { getStyles, variant, fontWeight },
    },
  }) => getStyles(variant.body1, fontWeight.bold)};
`;

interface TeamCaptainProps {
  readonly image: string;
}

export const TeamCaptain: FC<TeamCaptainProps> = ({ image }) => (
  <TextWrapper>
    <StyledTitle>
      <Content id="cid$#1907004#" />
    </StyledTitle>
    <StyledImage alt="Team Captain" src={image} size={ImageSize.SquareCarousel} />
    <CaptionName>
      <Content id="cid$#1937469#" />
    </CaptionName>
    <StyledTextBodyDiv>
      <Content id="cid$#1937470#" />
    </StyledTextBodyDiv>
    <StyledTextBodyDiv>
      <Content id="cid$#1937471#" />
    </StyledTextBodyDiv>
  </TextWrapper>
);
